export default __webpack_public_path__ + "static/media/exploded-view_labels.e3347560.png";